export const workoutTypes = [
  {
    name: 'Home Workouts',
    icon: '🏠',
    type: 'home',
  },
  {
    name: 'Gym Workouts',
    icon: '🏋️‍♂️',
    type: 'gym',
  },
  {
    name: 'Cardio Workouts',
    icon: '🏃',
    type: 'cardio',
  },
  {
    name: 'HIIT / Circuit',
    icon: '🔥',
    type: 'hiit',
  },
  {
    name: 'Core & Stability',
    icon: '💪',
    type: 'core',
  },
  {
    name: 'Stretching / Recovery',
    icon: '🧘',
    type: 'stretching',
  },
  {
    name: 'Sports',
    icon: '🧗',
    type: 'sports',
  },
];
